import {
    Theme,
    Typography
} from "@mui/material";
import { CommonLayout } from "../commonComponents";
import Recommendations from "./mutualFund/recommendations";

export default function InvestorRecommendations(): JSX.Element {
    return (
        // <CommonLayoutForInvestor>
        <CommonLayout>
            <>
                <Typography
                    variant="h1"
                    sx={(theme: Theme) => ({
                        lineHeight: "32.5px",
                        color: theme.palette.text.primary,
                        marginBottom: "25px"
                    })}
                >
                    Recommendations
                </Typography>
                <Recommendations />
            </>
        </CommonLayout>
        // </CommonLayoutForInvestor>
    )
}